import { partnerToken } from './PartnerTokenService';

export default {
  partnerToken,
};
